import { InboxCountTypeEnum } from '../../../entities/integration/configuration.interface';
const emailActivityTrackingTooltip = 'When enabled, Novu will auto-configure delivery webhooks using your existing API key. If they lack permissions, follow the manual set-up guide.';
const sendgridConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Email Activity Tracking',
        tooltip: emailActivityTrackingTooltip,
        type: 'switch',
        required: false,
        links: [
            {
                text: 'manual set-up guide',
                url: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/sendgrid',
            },
        ],
    },
    {
        key: 'inboundWebhookSigningKey',
        displayName: 'Inbound Webhook Signing Key',
        type: 'string',
        required: false,
    },
];
const resendConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Email Activity Tracking',
        tooltip: emailActivityTrackingTooltip,
        type: 'switch',
        required: false,
        links: [
            {
                text: 'manual set-up guide',
                url: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/resend',
            },
        ],
    },
    {
        key: 'inboundWebhookSigningKey',
        displayName: 'Inbound Webhook Signing Key',
        type: 'string',
        required: false,
    },
];
const anypostConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Email Activity Tracking',
        tooltip: emailActivityTrackingTooltip,
        type: 'switch',
        required: false,
        links: [
            {
                text: 'manual set-up guide',
                url: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/anypost',
            },
        ],
    },
    {
        key: 'inboundWebhookSigningKey',
        displayName: 'Inbound Webhook Signing Key',
        type: 'string',
        required: false,
    },
];
const mailgunConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Email Activity Tracking',
        tooltip: emailActivityTrackingTooltip,
        type: 'switch',
        required: false,
        links: [
            {
                text: 'manual set-up guide',
                url: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/mailgun',
            },
        ],
    },
    {
        key: 'inboundWebhookSigningKey',
        displayName: 'Inbound Webhook Signing Key',
        type: 'string',
        required: false,
    },
];
const sesConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Email Activity Tracking',
        tooltip: emailActivityTrackingTooltip,
        type: 'switch',
        required: false,
        links: [
            {
                text: 'manual set-up guide',
                url: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/ses',
            },
        ],
    },
];
const photonImessageConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Delivery & Read Receipts',
        tooltip: 'When enabled, Photon delivers outbound-echo and read-receipt events to Novu so message activity reflects delivered/read state.',
        type: 'switch',
        required: false,
    },
    {
        key: 'inboundWebhookSigningKey',
        displayName: 'Inbound Webhook Signing Key',
        type: 'string',
        required: false,
    },
];
export const photonImessageGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: photonImessageConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.photon.codes',
    },
];
export const pushConfigurations = [
    {
        key: 'inboundWebhookEnabled',
        displayName: 'Push Activity Tracking',
        tooltip: 'Enable receiving push events to track delivery status and user interactions with push notifications.',
        type: 'switch',
        required: false,
    },
    {
        key: 'pushResources',
        displayName: 'Push Resources',
        type: 'pushResources',
        required: false,
    },
];
const pushActivityTrackingGroup = (setupWebhookUrlGuide) => ({
    groupType: 'inboundWebhook',
    configurations: pushConfigurations,
    enabler: 'inboundWebhookEnabled',
    setupWebhookUrlGuide,
});
export const sendgridGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: sendgridConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/sendgrid',
    },
];
export const resendGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: resendConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/resend',
    },
];
export const anypostGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: anypostConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/anypost',
    },
];
export const mailgunGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: mailgunConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/mailgun',
    },
];
export const sesGroupConfigurations = [
    {
        groupType: 'inboundWebhook',
        configurations: sesConfigurations,
        enabler: 'inboundWebhookEnabled',
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/email/activity-tracking/manual-configuration/ses',
    },
];
export const pushpadGroupConfigurations = [
    pushActivityTrackingGroup('https://developer.android.com/develop/ui/views/notifications/build-notification'),
];
export const fcmGroupConfigurations = [
    pushActivityTrackingGroup('https://developer.android.com/develop/ui/views/notifications/build-notification'),
    {
        groupType: 'crossChannelConfigs',
        configurations: [
            {
                key: 'inboxCount',
                displayName: 'Use inbox count in badge',
                type: 'dropdown',
                value: InboxCountTypeEnum.NONE,
                placeholder: 'Select count type',
                dropdown: [
                    { name: 'None', value: InboxCountTypeEnum.NONE },
                    { name: 'Unread', value: InboxCountTypeEnum.UNREAD },
                    { name: 'Unseen', value: InboxCountTypeEnum.UNSEEN },
                ],
                required: false,
                tooltip: 'When selected, Novu will include the Inbox unread or unseen count in the FCM message payload. This will allow you to display the count in the app badge or use it in your custom logic.',
            },
        ],
        setupWebhookUrlGuide: 'https://docs.novu.co/platform/integrations/push?utm_campaign=in-app',
    },
];
export const expoGroupConfigurations = [
    pushActivityTrackingGroup('https://docs.expo.dev/push-notifications/sending-notifications/'),
];
export const apnsGroupConfigurations = [
    pushActivityTrackingGroup('https://developer.apple.com/documentation/usernotifications/unusernotificationcenterdelegate'),
];
export const pushWebhookGroupConfigurations = [
    pushActivityTrackingGroup('https://docs.novu.co/platform/integrations/push/push-webhook?utm_campaign=in-app'),
];
export const oneSignalGroupConfigurations = [
    pushActivityTrackingGroup('https://docs.novu.co/platform/integrations/push/onesignal'),
];
export const pusherBeamsGroupConfigurations = [
    pushActivityTrackingGroup('https://docs.novu.co/platform/integrations/push/pusher-beams'),
];
//# sourceMappingURL=provider-configuration.js.map